module.exports = __webpack_public_path__ + "img/emoji-angry-240x240.747b4365.png";